export default "__VITE_ASSET__CrJ$O8BH__"